module.exports = __webpack_public_path__ + "img/questionnaire-icon-orange.b89dfa8f.svg";